import React from 'react';
import dynamic from 'next/dynamic';

const AdImage = dynamic(() => import('../AdImage'), {
    ssr: false
});
const AdIframe = dynamic(() => import('../AdIframe'), {
    ssr: false
});
const AdHTML = dynamic(() => import('../AdHtml'), {
    ssr: false
});

type ImageAd = {
    id: string;
    renderType: 'image';
    image: { mobile: string; desktop: string };
    name: string;
};

type IframeAd = {
    id: string;
    renderType: 'iframe';
    code: string;
};

type HTMLAd = {
    id: string;
    renderType: 'html';
    preloadScript?: string;
    code: string;
};

type AdData = ImageAd | HTMLAd | IframeAd;

type Props = {
    data: AdData;
    desktopMinWidth: number;
    onRenderComplete: () => void;
};

export function renderAdContent({ data, desktopMinWidth, onRenderComplete }: Props) {
    if (!data) return null;
    switch (data.renderType) {
        case 'image':
            return (
                <AdImage
                    data={data}
                    desktopMinWidth={desktopMinWidth}
                    onRenderComplete={onRenderComplete}
                />
            );
        case 'html':
            return <AdHTML data={data} onRenderComplete={onRenderComplete} />;
        case 'iframe':
            return <AdIframe data={data} onRenderComplete={onRenderComplete} />;
    }
}
